<template>
  <layout-admin-dashboard-view
    :show-toolbar="false"

    :back-route="{ name: 'admin-dashboard' }">
    <template #title>
      <span>{{ translateTitleCase("justopp.bid.displayTitle") }}</span>
    </template>

    <template #default>
      <custom-crud-list
        v-bind="listConfiguration"
        @crud-list:items-updated="playground">
        <template #cell-createdAt="{ item }">
          <span>{{ translateDate(item.createdAt, "dateWithTime") }}</span>
        </template>

        <template #cell-amount="{ item }">
          <span>
            {{translateNumber (item.amount, 'currency', {'currency': item.AuctionProductType.Product.currency})}}
          </span>
        </template>
        <template #cell-productName="{ item }">
          <span>
            <saffron-link :to="{name: 'admin-product-edit-id', params: {id: item.AuctionProductType.Product.id}}">
              {{ item.AuctionProductType.Product.name }}
            </saffron-link>
          </span>
        </template>
        <template #cell-VendorId="{ item }">
          <span v-if="item.AuctionProductType.Product?.Vendor">

            <saffron-link :to="{name: 'admin-vendor-edit-id', params: {id: item.AuctionProductType.Product?.Vendor?.id}}">
              {{ item.AuctionProductType.Product?.Vendor?.name }}
            </saffron-link>
          </span>
          <span v-else>
            -
          </span>
        </template>

        <template #cell-isWinning="{ item }">
          <span v-if="item.AuctionProductType?.AuctionBids[0]">

            <span v-if="item.AuctionProductType?.AuctionBids[0].amount === item.amount">
              {{ t('core.yes') }}
            </span>
            <span v-else>
               {{ t('core.no')}}
            </span>
          </span>
          <span v-else>
           -
          </span>
        </template>
        <template #cell-OwnerId="{ item }">
          <span>
           {{ item?.Owner?.fullName }}
          </span>
        </template>
      </custom-crud-list>

      <modal ref="orderViewModal" size="l" title="Order Details">
        <spinner v-if="!order"></spinner>

        <block class="margin-2xl-bottom">
          <span
            ><strong>{{ translateUcFirst("justopp.bid.fields.id") }}:</strong>
            {{ order.id }}</span
          ><br />
          <span
            ><strong>{{ translateUcFirst("entity.user.fields.fullName") }}:</strong>
            {{ order?.Buyer?.fullName }}</span
          ><br />
          <span
            ><strong>{{ translateUcFirst("entity.user.fields.email") }}:</strong>
            {{ order?.Buyer?.email }}</span
          ><br />
        </block>

        <card title="ecommerce.order.admin.quoteWithExplain" class="margin-2xl-bottom">
          <cart :quote="order.Quote" :read-only="true" :show-action-bar="false"> </cart>
        </card>
        <card title="ecommerce.order.admin.buyerTitle" class="margin-2xl-bottom">
          <simple-value-list :list="buyerInformationList"></simple-value-list>
        </card>
      </modal>
    </template>
  </layout-admin-dashboard-view>
</template>

<script>
import asyncOperations from "@/client/extensions/composition/asyncOperations";
import CustomCrudList from "@/client/components/crud/customV1/List.vue";
import Cart from "@/client/components/ecommerce/Cart.vue";
export default {
  components: { CustomCrudList, Cart },
  layout: "adminDashboard",
  middleware: {
    requireSuperAdmin: {},
  },
  props: {},
  setup(props) {
    let { asyncOps, asyncOpsReady, asyncStatus } = asyncOperations(props);
    return { asyncOps, asyncOpsReady, asyncStatus };
  },
  meta: "justopp.bid.admin.pageTitle",
  data: function () {
    return {
      order: false,
      userForm: false,
      listConfiguration: {
        subject: "auctionBid",
        listSrc: "justopp/bid",
        initialOrdering: { key: "createdAt", direction: "desc" },
        showIdField: true, // bool deafult true
        sortable: false, //bool, default false
        publishable: false, //bool, default false
        enableMassActions: false,
        editRoutePrefix: "admin-",
      //  createRoutePrefix: "admin-",
       // deleteRoutePrefix: "ecommerce/",
        deleteRoute: "justopp/bid",
        additionalListData: {
          simplified: false,
          translate: false,
        },
        fields: {
          createdFrom: {
            listable: false,
            filterable: {
              name: "createdFrom",
              type: "DatePicker",
              placeholder: "justopp.bid.fields.createdFrom",
            },
            type: "DatePicker",
            label: "justopp.bid.fields.createdFrom",
          },
          createdBefore: {
            listable: false,
            filterable: {
              name: "createdBefore",
              type: "DatePicker",
              placeholder: "justopp.bid.fields.createdBefore",
            },
            label: "justopp.bid.fields.createdBefore",
          },

          // these are the table columns
          createdAt: {
            itemKey: "createdAt",
            label: "justopp.bid.fields.createdAt",
            filterable: false,
          },
          amount: {
            name: "amount",
            label: "justopp.bid.fields.amount",
            orderable: false,
          },
          productName: {
            name: "productName",
            label: "justopp.bid.fields.productName",
            orderable: false,
            filterable: {
              name: "productName",
              type: "text",
              placeholder: "justopp.bid.fields.productName",
            },

          },
          VendorId: {
            itemKey: "VendorId",
            label: "justopp.bid.fields.vendor",
            filterable: {
              name: "VendorId",
              type: "Select2",
              translateList: false,
              valueKey: "id",
              labelKey: "name",
              placeholder: "ecommerce.product.fields.vendorFilterPlaceholder",
              itemComponent: "iconItem",
              asyncListSource: "entity/Vendor",
              asyncListLive: false,
              textFilterAsSaffronListFilter: true,
              asyncDataTextFilterParamName: "title",
              multiple: false,
              asyncListData: {
                simplified: true,
              },
            }, // boolean, or object
          },
          OwnerId: {
            itemKey: "OwnerId",
            label: "justopp.bid.fields.user",
            filterable: {
              name: "OwnerId",
              type: "Select2",
              translateList: false,
              valueKey: "id",
              labelKey: "name",
              placeholder: "justopp.bid.fields.userPlaceholder",
              itemComponent: "iconItem",
              asyncListSource: "entity/User",
              asyncListLive: false,
              textFilterAsSaffronListFilter: true,
              asyncDataTextFilterParamName: "title",
              multiple: false,
              asyncListData: {
                simplified: true,
              },
            }, // boolean, or object
          },
          isWinning: {
            label: "justopp.bid.fields.isWinning",
            orderable: false,
          },
        },
        actions: {
          create: false,
          show: false,
          edit: false,
          delete: true,
          custom: {

          },
        },
      },
      asyncData: {
        userForm: "entity/user/update",
      },
    };
  },
  computed: {
    buyerInformationList() {
      const res = [];
      //  console.log(this.userForm.fields);
      Object.entries(this.userForm.fields).forEach(([key, field]) => {
        let label;

        if (field.placeholder) {
          label = field.placeholder;
        }
        if (field.label) {
          label = field.label;
        }
        res.push({ label: label, value: this?.order?.Buyer[key] });
      });
      return res;
    },
  },
  methods: {
    showOrder(order) {
      console.log("order", order);
      this.order = order;
      this.$refs["orderViewModal"].open();
    },
    playground(data) {
      if (data) {
        console.log('data', data);
      }
    },
  },
};
</script>

<style scoped lang="scss"></style>
